import React from "react";
import { createRoot, hydrateRoot, type Root } from "react-dom/client";
import App from "./App";
import "./global.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element '#root' not found");
}

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

let root: Root | null = null;

if (container.hasChildNodes()) {
  try {
    root = hydrateRoot(container, app, {
      onRecoverableError(error, info) {
        if (process.env.NODE_ENV !== "production") {
          console.warn("Recoverable hydration error", error, info);
        }
      },
    });
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.error("Hydration failed, falling back to client render", error);
    }
    container.innerHTML = "";
    root = createRoot(container);
    root.render(app);
  }
}

if (!root) {
  root = createRoot(container);
  root.render(app);
}
